import React, {useEffect, useState} from 'react';
import Header from '../components/Header';
import Hero from '../components/home/Hero';
import homeImage from '../assets/images/hero_bg_home.png';
import Villas from '../components/home/Villas';
import Mobile_Villas from '../components/home/Mobile_Villas';
import Villas_in_valle from '../components/home/Villas_in_valle';
import Gallery from '../components/home/Gallery';
import Discover from '../components/home/Discover';
import Reviews from '../components/home/Reviews';
import Short_Effective from '../components/home/Short_Effective';
import List_With_Us from '../components/home/List_With_Us';
import Sign_Up_Updates from '../components/home/Sign_Up_Updates';
import Latest_News from '../components/home/Latest_News';
import Footer from '../components/Footer';
import axios from "axios";
import BASE from "../config";
import Loader from "../components/Loader";

function Home() {
    const [loading, setLoading] = useState(true);
    const [locations, setLocations] =  useState([]);
    const [resorts, setResorts] =  useState([]);
    useEffect(() =>{
        setLoading(true)
        axios.get(BASE.BASE_API_URL+'/api/locations').then( res => {
            setLocations(res.data.locations);
        }).finally(() => {
            setLoading(false);
        });
    },[]);



    useEffect(() =>{
        setLoading(true)
        axios.get(BASE.BASE_API_URL+'/api/resorts').then( res => {
            setResorts(res.data.resorts);

        }).finally(() => {
                setLoading(false);
            });
    },[]);

    console.log("RESORTS: ",resorts);


    if (loading) {
        return <Loader />;
    }
  return (
    <div>
      <Header />
      <Hero setLoading={setLoading}  locations={locations}
        title="Explore our Luxury Algarve Villa Collection"
        backgroundImage={homeImage}
      />
      <Villas resorts={resorts}/>
      <Mobile_Villas />
      <Villas_in_valle />
      <Gallery />
      <Discover />
      <Reviews />
      <Short_Effective />
      <List_With_Us resorts={resorts} />
      <Sign_Up_Updates />
      <Latest_News />
      <Footer />
    </div>
  );
}

export default Home;